import type { Voice } from "@/audio/core/types";

/**
 * The approved production voice - "Palette C / Minimal Premium" from the
 * PR13-D Audio Lab's Round 1 audition, locked as the default foundation
 * for every ordinary event (SAFE, RUSH, buttons, skills, death, and every
 * CHAOS event). Clean, restrained, musical, premium - never harsh,
 * casino-like, or childish. The QA lab's OTHER two voices (Cosmic Arcade,
 * Neon Punch) are intentionally never promoted here - they exist only for
 * historical A/B comparison and must never be production-reachable (see
 * `src/audio/lab/voices.ts`, which imports this constant back to assemble
 * its own three-voice comparison table).
 */
export const MINIMAL_PREMIUM_VOICE: Voice = {
  tonicHz: 440, // A4 - a clean bell reference
  everydayShape: "sine",
  richShape: "triangle",
  percussiveShape: "sine",
  noiseFilterType: "bandpass",
  noiseBrightness: 0.8, // softer
  noiseQ: 2.2, // narrower - more tonal, less "noisy"
  attackScale: 1.4, // softer, more restrained onset
  releaseScale: 1.6, // more negative space/tail
  harmonicDetuneSemitones: 12, // an octave - bell/chime overtone
  shimmerTaps: [
    { delayMs: 140, gain: 0.28 },
    { delayMs: 280, gain: 0.14 },
    { delayMs: 420, gain: 0.06 },
  ], // the most spacious decay of the three - "special through harmony and space"
  panWidth: 0.3,
  loudnessTrim: 1.04, // compensates for a naturally softer voice so it never reads as "weak"/"sleepy"
  roughnessNoiseBoost: 0.5,
};
